// extracted by mini-css-extract-plugin
module.exports = {"button":"assessment-cta_button__kxGuk","small-btn":"assessment-cta_small-btn__Pobo7"};